import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    periodo: moment.utc(new Date('1900-01-01')).format('YYYY-MM-DD'),
    pjeInflacion: 0,
    rowVersion: null
};

const mutations = {
    updateField,

    'INICIALIZAR_PARAMETRO' (state, id) {
        state.id = id;
        state.periodo = moment.utc(new Date('1900-01-01')).format('YYYY-MM-DD');
        state.pjeInflacion = 0;
        state.rowVersion = null;
    },
    'SET_PARAMETRO' (state, parametro) {
        state.periodo = moment.utc(parametro.periodo).format('YYYY-MM-DD');
        state.pjeInflacion = parseFloat(parametro.pjeInflacion);
        state.rowVersion = parametro.rowVersion;
    },
    'SET_ROWVERSION' (state, params) {
        state.rowVersion = params.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, parametroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARAMETRO', parametroId);
            
            if (parametroId != 0) {
                apiAxios.get(`parametrosinflacion/${parametroId}/abm`) 
                    .then(res => {
                        commit('SET_PARAMETRO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let periodo = moment.utc(state.periodo).format('YYYY-MM') + '-01';

            let parametro = {
                periodo: periodo,
                pjeInflacion: parseFloat(state.pjeInflacion),
            }

            let url = 'parametrosinflacion';
            if (state.id != 0) {
                url += '/' + state.id;
                parametro.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, parametro)
                .then(res => {
                    commit('SET_ROWVERSION', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}